module.exports = __webpack_public_path__ + "static/media/check.f8862f56.svg";